import React from 'react';
import './Energysaving.css';
import Energyel from '../../../imgs/Energyel.webp';
import Lowtemper from '../../../imgs/Lowtemper.webp';
import Lowpressure from '../../../imgs/Lowpressure.webp';
import Fastresponse from '../../../imgs/Fastresponse.webp';

const cardData = [
  {
    img: Energyel,
    desc: "Energy-Saving 30%~50% Servo motor with energy-saving controlled hydraulic systems can save electricity up to 30%~50%."
  },
  {
    img: Lowtemper,
    desc: "Low Temperature Injection saves energy and keeps products tough with our innovative plasticizing system."
  },
  {
    img: Lowpressure,
    desc: "Low Pressure Injection ensures better mechanical protection and longer mould life. Also reduces stress and deformation."
  },
  {
    img: Fastresponse,
    desc: "Fast Response Speed optimized control system achieves best shooting rate response within 0.3 seconds."
  }
];

const Energysaving = () => {
  return (
    <div className="Energy-wrapper">
      <h1 className="Energy-title">FEATURES</h1>

      <div className="Energy-container">
        {cardData.map((card, index) => (
          <div className="Energy-card" data-aos="fade-down" key={index}>
            <img src={card.img} alt="energy-feature" />
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Energysaving;
